export const Resolved = 'resolved'

export const Rejected = 'rejected'
